module.exports = __webpack_public_path__ + "static/media/hotelBanner1.893c61fe.png";